import moment from 'moment';

export const formatMessageDateTime = (value) => {
  if (!value) {
    return '';
  }

  return moment(value).format('DD/MM/YYYY HH:mm');
};

export const daySeparatorLabel = (value) => {
  if (!value) {
    return null;
  }

  const date = moment(value).startOf('day');
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  if (date.isSame(today, 'day')) {
    return 'Hoje';
  }

  if (date.isSame(yesterday, 'day')) {
    return 'Ontem';
  }

  return date.format('DD/MM/YYYY');
};

export const isSameChatDay = (left, right) => {
  if (!left || !right) {
    return false;
  }

  return moment(left).format('YYYY-MM-DD') === moment(right).format('YYYY-MM-DD');
};
